// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})


if(window.innerWidth > 960){
    if (!document.querySelector("body").classList.contains("home")) {
        let heightTopPublication = document.querySelector('.cover__informations').clientHeight + 'px';
        let divTopImage = document.querySelector('.cover__image-wrapper');
        divTopImage.style.height = heightTopPublication;
    }
}